import MenuItemSection from '../../MenuSection';
import { ICategoryWithChildren } from '../utilities';
import { ISection } from 'src/types/menu.types';

interface IMenuItemSectionContainer {
  menuId: string;
  category: ICategoryWithChildren;
  handleSectionModal: (value?: string | null) => void;
  onClickNewItem: (sectionId?: string) => void;
  upDisplayOrder?: number;
  downDisplayOrder?: number;
  isAssignedToMealtime: boolean | undefined;
  tooltipPosition: 'top' | 'bottom';
  sections: ISection[];
}

const MenuItemSectionContainer = ({ category, ...rest }: IMenuItemSectionContainer) => {
  const { children } = category;
  return (
    <>
      <MenuItemSection {...rest} section={category} />
      {children.length > 0 && (
        <div>
          {children.map((subcategory: ICategoryWithChildren, index) => (
            <MenuItemSectionContainer
              key={subcategory.sectionId}
              {...rest}
              category={subcategory}
              upDisplayOrder={children[index - 1]?.displayOrder}
              downDisplayOrder={children[index + 1]?.displayOrder}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default MenuItemSectionContainer;
